module.exports = __webpack_public_path__ + "img/sy_search.c4033462.png";